export default __webpack_public_path__ + "static/media/element_70.b94ea921.avif";